import React, { Component } from 'react';
import { hiddenPassword, showPassword } from '../../../Images/Images'
import { passIcon } from '../../../Images/SettingsSGV.js'

export default class PasswordTextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passVisible: false
    }
  }
  componentDidMount() {
    this.inputText = this.refs["inputTextPass"];
  }
  focus() {
    this.inputText.focus();
  }
  preventDragHandler(e) {
    e.preventDefault();
    this.setState({ passVisible: false });
  }
  render() {
    return (
      <div className={"passwordTextContainer " + (this.props.hasError ? " hasError" : "")} style={{ height: this.props.height || 26, width: this.props.width || 158, marginLeft: (this.props.marginLeft !== null ? this.props.marginLeft : 10) }}>
        {this.props.image && <div className="iconForm">{passIcon}</div>}
        <input type={this.state.passVisible ? "text" : "password"}
          ref="inputTextPass"
          className={"passwordLocked " + (this.props.image ? "withImage" : "")}
          maxLength="30"
          value={this.props.value}
          onChange={event => this.props.onChange(event.target.value)}
          onBlur={() => this.props.onBlur && this.props.onBlur()}
          onKeyPress={event => { event.key === 'Enter' && (this.props.onEnterKey && this.props.onEnterKey()) }} />
        {this.state.passVisible ?
          <img src={showPassword} alt="icon" draggable="false" className={"changePassImgItem " + (this.props.value && "visible")} onMouseUp={() => this.setState({ passVisible: false })} onDragStart={(e) => this.preventDragHandler(e)} />
          :
          <img src={hiddenPassword} alt="icon" draggable="false" className={"changePassImgItem " + (this.props.value && "visible")} onMouseDown={() => this.setState({ passVisible: true })} onDragStart={(e) => this.preventDragHandler(e)} />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/PasswordTextArea.jsx